<template>
  <q-card style="width: 420px">
    <div class="row items-center q-ma-md">
      <div class="text-subtitle1">
        {{ FarmName }}
      </div>
      <q-space />
      <q-btn
        :outline="!showInfo"
        :unelevated="showInfo"
        icon="info"
        :color="badgeColor"
        :text-color="showInfo ? 'black' : badgeColor"
        class="q-mr-sm"
        @click="showInfo = !showInfo"
      />
      <q-btn
        unelevated
        icon="clear"
        :color="badgeColor"
        text-color="black"
        v-close-popup
      />
    </div>
    <q-separator :color="badgeColor" />

    <q-slide-transition>
      <div v-show="showInfo">
        <div class="q-pa-md">
          <div class="text-weight-bold q-pb-sm">{{ info.title }}</div>
          <ul class="q-my-none q-pl-md">
            <li v-for="line in info.lines" :key="line" class="q-pb-xs">
              {{ line }}
            </li>
          </ul>
          <div class="text-caption text-grey-7 q-pt-sm">
            {{ info.other }}
          </div>
        </div>
        <q-separator :color="badgeColor" />
      </div>
    </q-slide-transition>

    <div class="scroll" style="max-height: calc(100vh - 200px)">
      <div class="q-pa-md text-subtitle1">
        <div
          v-for="(alert, index) in EmailBody"
          :key="alert.pond + alert.msg + index + 'msg'"
        >
          {{ alert.pond }} -
          {{ alert.msg }}
        </div>
      </div>

      <q-separator v-if="duplicateEmails.length > 0" :color="badgeColor" />

      <div class="q-py-sm">
        <div
          v-for="email in duplicateEmails"
          :key="email.email_id + 'dupEmails'"
          class="q-py-xs q-px-md"
        >
          <div>
            {{ formatWithSeconds(email.date) }}
            <span v-if="email.archived" class="text-grey-7 q-pl-sm">
              (archived)
            </span>
          </div>
        </div>
      </div>
    </div>
  </q-card>
</template>

<script>
import { date } from 'quasar';
import { decoder } from '@/lib/helpers.js';

export default {
  name: 'EmailDuplicates',
  props: {
    duplicateEmails: {
      type: Array,
      required: true
    },
    duplicateEmailsType: {
      type: String,
      required: true,
      validator: (v) => ['cluster', 'spread'].includes(v)
    },
    // How far back the counts look, e.g. '2 months'
    lookback: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showInfo: false
    };
  },
  methods: {
    formatWithSeconds(unixSec) {
      return date.formatDate(
        new Date(unixSec * 1000),
        'ddd MMM DD YYYY - h:mm:ss A'
      );
    }
  },
  computed: {
    badgeColor() {
      return this.duplicateEmailsType === 'cluster' ? 'pink-5' : 'amber-14';
    },
    info() {
      const sameAlert =
        'It counts as the same alert when the farm, pond and message match.';
      const archived = 'Archived alerts still count and are marked (archived).';

      if (this.duplicateEmailsType === 'cluster') {
        return {
          title: 'Pink: repeat alerts',
          lines: [
            'This alert went off more than once within 48 hours.',
            'The number counts every time it went off within 48 hours of ' +
              `another time, looking back ${this.lookback}.`,
            'Separate bursts add together: 3 alerts on one day and 2 more ' +
              'a few weeks later show as 5.',
            sameAlert,
            archived
          ],
          other: 'Amber, when shown, counts how many days it went off.'
        };
      }

      return {
        title: 'Amber: recurring alert',
        lines: [
          'This alert keeps coming back: its first and latest times are ' +
            'more than 48 hours apart.',
          'The number is how many different days it went off, looking ' +
            `back ${this.lookback}.`,
          'The list shows one time per day (the latest alert that day).',
          sameAlert,
          archived
        ],
        other: 'Pink, when shown, counts how often it repeated within 48 hours.'
      };
    },
    FarmName() {
      const farmId = this.Email?.farm_id;

      if (farmId === 0) {
        return 'SPAM EMAIL !!!';
      }

      const farm = this.$store.state.farmList.find(
        (e) => e.id === parseInt(farmId)
      );

      return farm ? decoder(farm.farm_name) : '';
    },
    Email() {
      return this.duplicateEmails[0];
    },
    EmailBody() {
      return this.Email?.emailBody ?? [];
    }
  }
};
</script>

<style scoped></style>
